import { FEATURE_FLAGS } from "dashboard/featureFlags";
import { frontendURL } from "dashboard/helper/URLHelper";

const KanbanBoardPage = () => import("kanban/pages/KanbanBoardPage.vue");
const KanbanBoardSettingsPage = () =>
	import("kanban/pages/KanbanBoardSettingsPage.vue");
const KanbanOverviewPage = () => import("kanban/pages/KanbanOverviewPage.vue");
const KanbanProductsPage = () => import("kanban/pages/KanbanProductsPage.vue");

const KANBAN_ROUTE_PERMISSIONS = ["administrator", "agent", "kanban_manage"];

export const routes = [
	{
		path: frontendURL("accounts/:accountId/kanban/overview"),
		component: KanbanOverviewPage,
		name: "kanban_list",
		meta: {
			permissions: KANBAN_ROUTE_PERMISSIONS,
			// Note: No featureFlag here - the page handles displaying a disabled state
		},
	},
	{
		path: frontendURL("accounts/:accountId/kanban/:boardId/settings"),
		component: KanbanBoardSettingsPage,
		name: "kanban_board_settings",
		meta: {
			permissions: KANBAN_ROUTE_PERMISSIONS,
			featureFlag: FEATURE_FLAGS.KANBAN,
		},
	},
	{
		path: frontendURL("accounts/:accountId/kanban/:boardId/products"),
		component: KanbanProductsPage,
		name: "kanban_board_products",
		meta: {
			permissions: KANBAN_ROUTE_PERMISSIONS,
			featureFlag: FEATURE_FLAGS.KANBAN,
		},
	},
	{
		path: frontendURL("accounts/:accountId/kanban/:boardId?"),
		component: KanbanBoardPage,
		name: "kanban_board_show",
		meta: {
			permissions: KANBAN_ROUTE_PERMISSIONS,
			featureFlag: FEATURE_FLAGS.KANBAN,
		},
		children: [
			{
				path: "create",
				name: "kanban_task_create",
				component: KanbanBoardPage,
				meta: {
					permissions: KANBAN_ROUTE_PERMISSIONS,
					featureFlag: FEATURE_FLAGS.KANBAN,
				},
			},
			{
				path: "task/:taskId",
				name: "kanban_task_show",
				component: KanbanBoardPage,
				meta: {
					permissions: KANBAN_ROUTE_PERMISSIONS,
					featureFlag: FEATURE_FLAGS.KANBAN,
				},
			},
		],
	},
];
